export default {"src":"/_next/static/media/assistant-nurse-with-medium-green-text-box.9d97654c.svg","height":373,"width":260};